const typeDocumentChoice = [
    { id: 0, name: "CRM" },
    { id: 1, name: "CRN" },
    { id: 2, name: "CRF" },
    { id: 3, name: "CREF" },
    { id: 4, name: "CRMV" },
    { id: 5, name: "CREFITO" },
    { id: 6, name: "CRBM" },
    { id: 7, name: "COREN" },
    { id: 8, name: "CRO" },
];

export default typeDocumentChoice;
